interface PageMeta {
  label: string;
  order?: number;
  section?: string;
  sectionRoot?: boolean;
}

interface PageModule {
  meta: PageMeta;
  [key: string]: unknown;
}

const pageModules = import.meta.glob<PageModule>(['./pages/*.tsx', '!./pages/*.test.tsx'], { eager: true });

function getPageComponent(mod: PageModule): React.ComponentType {
  const key = Object.keys(mod).find((k) => k !== 'meta' && typeof mod[k] === 'function');
  if (!key) {
    throw new Error('Page module is missing a component export');
  }
  return mod[key] as React.ComponentType;
}

function getPathFromFilename(filename: string): string {
  const match = filename.match(/\.\/pages\/(.+)\.tsx$/);
  if (!match) return '/';
  const name = match[1];
  return name === 'home' ? '/' : `/${name}`;
}

export const pages = Object.entries(pageModules)
  .filter(([, mod]) => mod.meta)
  .map(([filename, mod]) => ({
    path: getPathFromFilename(filename),
    label: mod.meta.label,
    order: mod.meta.order ?? 50,
    section: mod.meta.section,
    sectionRoot: mod.meta.sectionRoot ?? false,
    component: getPageComponent(mod),
  }))
  .sort((a, b) => a.order - b.order);
